export const ADMIN_SECTIONS = [
  { id: "batch", title: "Master Control", tint: "#F4F1EA", border: "#E3DCCB" },
  { id: "site", title: "Site Basics", tint: "#FDF8EE", border: "#EADFC8" },
  { id: "announcement", title: "Announcement", tint: "#FBF0F4", border: "#F0DCE5" },
  { id: "social", title: "Social Links", tint: "#EEF5FB", border: "#D6E4F0" },
  { id: "festival", title: "Festival Corner", tint: "#FFF4E6", border: "#F5DFC2" },
  { id: "programs", title: "Programs & Registration", tint: "#EDF4FF", border: "#D4E2F8" },
  { id: "demo", title: "Demo", tint: "#FDF6F0", border: "#F2DFCE" },
  { id: "feedback", title: "Feedback", tint: "#FDF3EA", border: "#F2DFCE" },
  { id: "testimonials", title: "Testimonials", tint: "#F7F7F2", border: "#E4E4DA" },
  { id: "guides", title: "Guides", tint: "#EDF7F5", border: "#D2E8E3" },
  { id: "past", title: "Past Batch", tint: "#FCF0F3", border: "#F0DCE3" },
  { id: "welcome", title: "Welcome Message", tint: "#F1FBF4", border: "#CDEBD6" },
  { id: "classroom", title: "Classroom", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "classroom-main", no: "13.1", title: "Day 1–6 | Day 1-10 Videos & Schedule", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "classroom-tasks", no: "13.2", title: "Daily Mandatory Tasks", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "classroom-videos", no: "13.3", title: "Classroom Videos", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "classroom-reports", no: "13.4", title: "Reports & Statistics", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "classroom-player", no: "13.5", title: "Video Player — What participants see", tint: "#FBF4E8", border: "#EBD9BB" },
  { id: "zoom", title: "Zoom Attendance", tint: "#EAF3FF", border: "#C9DDF7" },
  { id: "wa-hub", title: "WhatsApp Section", tint: "#EEF9F2", border: "#BFE6CD" },
  { id: "present", title: "Present Batch", tint: "#EEF3FA", border: "#D3DFEE" },
  { id: "batch-report", title: "Batch Report", tint: "#F3F0FA", border: "#DCD4EC" },
  { id: "guide-info", title: "Guides", tint: "#EEF6F1", border: "#CFE4D8" },
  { id: "approval", title: "Approval Pending", tint: "#FFF6E5", border: "#F3DFB5" },
  { id: "export", title: "Export", tint: "#EDF8F3", border: "#D3EAE0" },
  { id: "registrations", title: "Future Batch", tint: "#FFFFFF", border: "#E4E4DA" },
  { id: "schools", title: "Schools", tint: "#EEF2F8", border: "#CBD8EA" },
  { id: "chatbot", title: "TalkingBot & ChatBot", tint: "#FDF1E7", border: "#F2D5C2" },
  { id: "layout", title: "Page Layout", tint: "#EEF4F0", border: "#CFE0D5" },
  { id: "security", title: "Organizer Security & Activity Log", tint: "#F4EEF0", border: "#E3CFD6" },
];

export const sectionMeta = (id) => ADMIN_SECTIONS.find((s) => s.id === id);
export const sectionNo = (id) => { const s = sectionMeta(id); if (s?.no) return s.no; return String(ADMIN_SECTIONS.filter((x) => !x.no).findIndex((x) => x.id === id) + 1).padStart(2, "0"); };
export const sectionLabelNo = (id) => String(Number(sectionNo(id)));
